module.exports = __webpack_public_path__ + "static/media/dolar.ab24202a.svg";